import { Inject, Injectable, LOCALE_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalizedSchemaService {
  private readonly locale: 'de' | 'en';
  private readonly siteOrigin = 'https://www.albcode.de';

  constructor(@Inject(LOCALE_ID) localeId: string) {
    this.locale = localeId.startsWith('en') ? 'en' : 'de';
  }

  serialize(data: unknown): string {
    return JSON.stringify(this.localizeUrls(data));
  }

  private localizeUrls(value: unknown, key?: string): unknown {
    if (Array.isArray(value)) return value.map(item => this.localizeUrls(item));
    if (value && typeof value === 'object') {
      return Object.fromEntries(Object.entries(value).map(([entryKey, entryValue]) => [
        entryKey,
        this.localizeUrls(entryValue, entryKey),
      ]));
    }
    if (typeof value !== 'string' || !['url', 'item'].includes(key ?? '') || !value.startsWith(this.siteOrigin)) {
      return value;
    }

    const url = new URL(value);
    const path = url.pathname.replace(/^\/(de|en)(?=\/|$)/, '') || '/';
    url.pathname = this.locale === 'en'
      ? `/en${path === '/' ? '/' : path.replace(/\/$/, '')}`
      : path;
    return url.toString();
  }
}
